import { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";

import { TooltipWrapper } from "@app/shared";
import { UserContext } from "@app/user";
import CreateProject from "./createProject";
import getOptions from "./data/options";
import { FieldGroup } from "./interfaces";
import { QESCheckbox } from "@app/shared/qes-standards";
import WizardStep from "./WizardStep";


interface CreateProjectStepOptionsProps extends RouteComponentProps {
  baseUrl: string;
  completionTracker: boolean[];
  createProjectModel: CreateProject;
  handleUpdate: (property: UpdateResourceKeys) => void;
  hideClosestProviderReportOption: boolean;
  hideCMSApplicationCredit: boolean;
  hideCreateStandards: boolean;
  hidePracAtLocCondifence: boolean;
  hideProviderClaimsActivity: boolean;
  isZipProject: boolean;
  showNetworkIntegrityDashboard: boolean;
  onNextClick: () => void;
  progressList: string[];
  currentIndex: number;
  hideEnterpriseComplianceDashboard: boolean;
  hideMotiveAppropriatenessScore: boolean;
  hideStrictTimeDistance: boolean;
  hideCareJourneyScores: boolean;
}

interface CreateProjectStepOptionsState {
  restartApp: boolean;
}

type UpdateResourceKeys = keyof CreateProject;

export default class CreateProjectStepOptions extends Component<CreateProjectStepOptionsProps, CreateProjectStepOptionsState> {
  constructor(props: CreateProjectStepOptionsProps) {
    super(props);
    this.state = {
      restartApp: !props.completionTracker.filter((_, index) => (props.currentIndex - 1) > index).every(step => step),
    };
  }

  public render() {
    if (this.state.restartApp) {
      return <Redirect to={`${this.props.baseUrl}/1`} />;
    }

    return (
      <WizardStep {...this.props} heading="Create a New Project" subheading="Project Options" baseUrl={this.props.baseUrl} prevUrl={(this.props.currentIndex - 1).toString()} nextUrl={(this.props.currentIndex + 1).toString()} progressList={this.props.progressList} isNextDisabled={this.handleIsNextDisabled()} onNextClick={this.props.onNextClick}>
        <UserContext.Consumer>
          {(user) => (
            getOptions<CreateProject>(
              {
                accuracyAndAdequacy: this.props.createProjectModel.accuracyAndAdequacy,
                displayOnNetworkAccordion: this.props.createProjectModel.displayOnNetworkAccordion,
                enablePatternOfCareProvidersOption: this.props.createProjectModel.hasZipSummaries && this.props.createProjectModel.showNextClosestNetworkProviders,
                enableRegulatoryExceptionReportsOption: this.props.createProjectModel.hasZipSummaries && this.props.createProjectModel.showNextClosestNetworkProviders,
                hideCMSApplicationCredit: this.props.hideCMSApplicationCredit,
                hideCareJourneyScores: this.props.hideCareJourneyScores,
                hideClosestProviderReport: this.props.hideClosestProviderReportOption,
                hideCreateStandards: this.props.hideCreateStandards,
                hideEnterpriseComplianceDashboard: this.props.hideEnterpriseComplianceDashboard,
                hideMotiveAppropriatenessScore: this.props.hideMotiveAppropriatenessScore,
                hidePciData: !this.props.createProjectModel.adequacyTemplateCollectionId,
                hidePracAtLocCondifence: this.props.hidePracAtLocCondifence,
                hideProviderClaimsActivity: this.props.hideProviderClaimsActivity,
                hideStrictTimeDistance: this.props.hideStrictTimeDistance,
                isZipProject: this.props.isZipProject,
                showAffiliationsInsights: this.props.createProjectModel.showAffiliationsInsights,
                showNetworkIntegrityDashboard: this.props.showNetworkIntegrityDashboard,
                showPciDataChecked: this.props.createProjectModel.showPciData,
                useAccuracy: this.props.createProjectModel.accuracyTemplateCollectionId !== null,
                userRoles: user.roles
              }
            ).map((fieldset: FieldGroup<CreateProject>) => {
              if (fieldset.fields.length > 0) {
                return (
                  <div className="col-12 col-sm-5 d-inline-block align-top mt-5" key={fieldset.title}>
                    <h3>{fieldset.title}</h3>
                    {fieldset.fields.map((option) => (
                      <div className="row" key={option.key}>
                        <div className="col-12">
                          <TooltipWrapper text={option.tooltip} tooltipWidth="20rem">
                            <QESCheckbox
                              containerClassName={!!option.dependency ? "ml-4" : ""}
                              className="custom-control-inline"
                              checked={!!this.props.createProjectModel[option.key as keyof CreateProject]}
                              disabled={option.disabled}
                              testId={"create-project-step-options__" + option.key + "-checkbox"}
                              onChange={() => {
                                this.props.handleUpdate(
                                  option.key as keyof CreateProject,
                                );
                              }}
                              label={option.title}
                            />
                          </TooltipWrapper>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              }
            })
          )}
        </UserContext.Consumer>
      </WizardStep>
    );
  }

  private handleIsNextDisabled() {
    return false;
  }
}
